import React from 'react';
import PropTypes from 'prop-types';
import pathfinder from '@fiverr-private/pathfinder';
import SellerLevel from '../../../components/SellerLevel';
import ProfileLink from './ProfileLink';

import './index.scss';

const ProfileName = ({
    user,
    noLink,
    onUsernameClick,
    isUserOnline,
    isStudio,
    isLimitedEdition,
    isNewSeller,
    tooltipPosition
}) => {

    const userProfileLink = pathfinder('short_user', { id: user.username });

    return (
        <div className="profile-name">
            <span className="user-status">
                <ProfileLink userName={user.username}
                    noLink={noLink}
                    link={userProfileLink}
                    onUsernameClick={onUsernameClick}/>
                {isUserOnline &&
                    <i className="user-online-circle"/>}
            </span>
            {!isStudio &&
                <SellerLevel achievement={user.achievement}
                    isPro={user.is_pro}
                    isLimitedEdition={isLimitedEdition}
                    isNewSeller={isNewSeller}
                    tooltipPosition={tooltipPosition}/>
            }
        </div>
    );
};

ProfileName.propTypes = {
    user: PropTypes.object,
    noLink: PropTypes.bool,
    onUsernameClick: PropTypes.func,
    isUserOnline: PropTypes.bool,
    isStudio: PropTypes.bool,
    isLimitedEdition: PropTypes.bool,
    isNewSeller: PropTypes.bool,
    tooltipPosition: PropTypes.string
};

export default ProfileName;
